<template>
  <div class="content">
    <div class="bannerWrap">
      <div class="topbanner EC_width display_between">
        <div class="bannerleft">
          <img src="/image/jigou/zhuanjiabanner.png"
               style="width: 100%;">
        </div>
        <div class="bannerright">
          <img src="/image/geren/index3tuceng.png"
               class="shan">
          <div class="bannerTitle">欢迎加入专家智库</div>
          <div class="bannerline">
          </div>
          <div class="bannerText">
            学科建设频道，旨在为广大会员提供全科医学方向、人才示培养、师资队伍、社会服务和文化发展等领域的最新内容与经验。 </div>
          <div class="marginTop20">
            <a href="javascript:void(0);"
               class="bannerBtn">欢迎申请入驻</a>
          </div>
        </div>
      </div>
    </div>
    <div class="EC_width marginTop40">
      <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
        学院名人堂
      </div>
      <div class="positionBtn EC_width">
        <swiper :options="optionsSwiper2"
                ref="mySwiper"
                v-if="apiData.banner.length > 0">
          <swiper-slide v-for="(item,index) in apiData.banner"
                        :key="index">
            <a href="javascript:;"
               class="mediaImg">
              <img :src="item.img"
                   style="width: 229px; height: 229px;">
              <p>{{item.name}}</p>
              <div class="marginTop20">
                <img src="/image/jigou/liaotian.png"
                     alt=""
                     class="activeimg">
                <img src="/image/jigou/liaotianhhui.png"
                     alt=""
                     class="norimg">
                <span class="activeSlide"
                      style="margin-right: 10px">{{item.msg}}</span>
                <img src="/image/jigou/chakan.png"
                     class="activeimg">
                <img src="/image/jigou/chakanhui.png"
                     class="norimg">
                <span class="activeSlide">{{item.show}}</span>
              </div>
            </a>
          </swiper-slide>

        </swiper>
        <div class="prevbutton2">&lt;</div>
        <div class="nextbutton2">&gt;</div>
      </div>
      <div class="border_bottom_18 display_between  marginTop40 marginBottom20">
        <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
          发现专家
        </div>
        <div>
          <div class="search">
            <span class="SCnum"
                  @click="taggleletter=true">{{letter}} <img src="/image/jigou/xialaSC.png"
                   alt=""
                   class="xiala"></span>
            <input type="text"
                   placeholder="输入专家姓名"
                   class="SCinput">
            <img src="/image/jigou/searchIcon.png"
                 alt=""
                 class="SCimg"
                 @click="Seach">
            <div class="letterWrap"
                 v-if="taggleletter">
              <span @click="letterClick(item)"
                    class="letter"
                    v-for="(item,index) in letterArr"
                    :key="index">{{item}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="display_flex">
        <div class="menuList">
          <div class="menuBlock">
            <p class="menuTitle">学科专长</p>
            <p class="menuli"
               v-for="(item,index) in apiData.xueke"
               :key="index">{{item.title}}</p>
          </div>
          <div class="menuBlock">
            <p class="menuTitle">技术专长</p>
            <p class="menuli"
               v-for="(item,index) in apiData.jishu"
               :key="index">{{item.title}}</p>
          </div>
          <div class="menuBlock">
            <p class="menuTitle">专家来源</p>
            <p class="menuli"
               v-for="(item,index) in apiData.zhuanjia"
               :key="index">{{item.title}}</p>
          </div>
        </div>
        <div class="flex1 marginLeft50">
          <div class="display_between marginBottom40"
               v-for="(item,index) in people"
               :key="index">
            <div class="display_flex">
              <img :src="item[0].img">
              <div class="display_column marginTop20 marginLeft20">
                <p class="fontsize22 fontBold marginBottom10">{{item[0].name}}</p>
                <p>{{item[0].sign}}</p>
                <p>{{item[0].adress}}</p>
                <p>{{item[0].university}}</p>
              </div>
            </div>
            <div class="display_flex">
              <img :src="item[1].img">
              <div class="display_column marginTop20 marginLeft20">
                <p class="fontsize22 fontBold marginBottom10">{{item[1].name}}</p>
                <p>{{item[1].sign}}</p>
                <p>{{item[1].adress}}</p>
                <p>{{item[1].university}}</p>
              </div>
            </div>
          </div>
          <pagination></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from "lodash"
export default {
  name: "expertEnter",
  data () {
    return {
      letterArr: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      letter: "按字母",
      taggleletter: false,
      apiData: "",
      people: [],
      optionsSwiper2: {
        loop: true, //开启循环
        loopedSlides: 5, //在loop模式下使用slidesPerview:'auto',还需使用该参数设置所要用到的loop个数。
        slidesPerView: 3, //设置slider容器能够同时显示的slides数量(carousel模式)。另外，支持'auto'值，会根据容器container的宽度调整slides数目。
        effect: 'coverflow', //可以实现3D效果的轮播,
        pagination: '.swiper-pagination', //分页器
        centeredSlides: true, //设定为true时，active slide会居中，而不是默认状态下的居左。
        slideActiveClass: 'my-slide-active',
        slideToClickedSlide: true,
        observer: true,
        observeParents: true,
        coverflowEffect: {
          rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
          stretch: 50, //每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
          depth: 150, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
          modifier: 1.3, //depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
          slideShadows: false, //开启slide阴影。默认 true。
        },
        navigation: {
          nextEl: '.nextbutton2',
          prevEl: '.prevbutton2',
          disabledClass: 'my-button-disabled',
        },
        on: {
          slideChange: () => {
            // alert('改变了，activeIndex为'+this.swiper.activeIndex);
          },
        },
      }
    }
  },
  methods: {
    getData () {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        that.apiData = data.expertEnter;
        var usepeople = data.expertEnter.people;
        this.people = lodash.chunk(usepeople, 2);
      })
    },
    letterClick (index) {

      this.letter = index;
      this.taggleletter = false
    },
    Seach () {

    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getData()
    })

  }
}
</script>

<style scoped>
.wrap {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 60px;
}
.qk_head {
    height: 77px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.pub_left_logo {
    width: 420px;
}

.pub_center_menu {
    flex: 1;
    height: 100%;
}

.pub_menu {
    list-style: none;
    padding: 0;
    margin: 0;
    overflow: hidden;
    height: 100%;
}

.pub_menu li {
    float: left;
    height: 100%;
    line-height: 77px;
}

.pub_menu li a {
    padding: 0 20px;
}

.pub_menu_active a {
    color: #0b8686;
}

.pub_right_opra {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.inputRelative {
    position: relative;
    display: inline-block;
}

.pub_head_bar_search {
    width: 200px;
    height: 24px;
    box-sizing: border-box;
    border-radius: 24px;
    outline: none;
    border: 1px solid #ddd;
    padding-left: 12px;
}

.inputRelative img {
    position: absolute;
    right: 11px;
    top: 3px;
    cursor: pointer;
}

.pub_mes_img {
    margin: 0 20px;
}

.pub_bar_headimg {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 24px;
    overflow: hidden;
    line-height: 24px;
    text-align: center;
    border: 1px solid #ddd;
}

/* 面包屑导航 */
.breadcrumb_wrap {
    min-width: 1300px;
    list-style: none;
    height: 40px;
    background: #f2f2f2;
    display: flex;
}
.set_breadcrumb {
    list-style: none;
    line-height: 40px;
    height: 100%;
    padding: 0;
}
.set_breadcrumb li {
    display: inline-block;
    font-size: 12px;
    color: #0b8485;
}
.set_breadcrumb li ~ li:before {
    content: '>';
    margin-left: 4px;
    margin-right: 4px;
    color: #333;
}
.set_breadcrumb li a {
    display: inline-block;
    font-size: 12px;
    color: #333;
}
.breadcrumb_search input {
    width: 200px;
    height: 30px;
    box-sizing: border-box;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    outline: none;
    border: 1px solid #f2f2f2;
    padding-left: 10px;
}
.ArrIcon {
    display: inline-block;
    width: 50px;
    height: 30px;
    background: #0b8686;
    border-radius: 0 30px 30px 0;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
}
.blocknext,
.blockpre {
    display: inline-block;
    width: 16px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    box-sizing: border-box;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 10px;
    z-index: 10;
    cursor: pointer;
    outline: none;
}
.blocknext {
    right: 0;
}
.blockpre {
    left: 0;
}
/* 轮播按钮 */
.nextbutton,
.prevbutton,
.nextbutton2,
.prevbutton2 {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 40%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}
.nextbutton2,
.prevbutton2 {
    top: 40%;
}
.nextbutton,
.nextbutton2 {
    right: -30px;
    left: auto;
}

.prevbutton,
.prevbutton2 {
    right: auto;
    left: -30px;
}

.my-button-disabled {
    background: #ddd;
    color: #999;
}

.content {
    flex: 1;
}

.bannerWrap {
    height: 450px;
    padding-top: 40px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #dbeded, #ffffff);
}

/* 上部banner */

.topbanner {
    height: 380px;
}

.bannerleft {
    width: 890px;
    height: 380px;
    background: #005660;
    box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
    border-radius: 20px 0px 0px 0px;
}

.bannerright {
    width: 299px;
    height: 380px;
    padding: 50px 40px;
    box-sizing: border-box;
    position: relative;
    background: #006773;
    box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
    border-radius: 0px 0px 20px 0px;
}

.shan {
    position: absolute;
    right: 0;
    bottom: 0;
}

.bannerTitle {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 38px;
}

.bannerText {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 25px;
}

.bannerline {
    width: 40px;
    height: 1px;
    background: #ffffff;
    margin-top: 20px;
    margin-bottom: 18px;
}

.bannerBtn {
    display: inline-block;
    width: 121px;
    height: 32px;
    background: #ffffff;
    border-radius: 16px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #000000;
    line-height: 32px;
    text-align: center;
}
/* 轮播宽度 */
.positionBtn {
    margin-top: 20px;
    position: relative;
    width: 1300px;
}
.swiper-slide {
    text-align: center;
}
.mediaImg {
    display: inline-block;
    text-align: center;
    width: 229px;
    height: 229px;
}
.activeimg {
    display: none;
    margin-right: 5px;
}
.norimg {
    margin-right: 5px;
}
.my-slide-active .activeSlide {
    color: #0d8b8c;
}
.my-slide-active .norimg {
    display: none;
}
.my-slide-active .activeimg {
    display: inline-block;
}

.menuBlock {
    background: #f6f7fb;
    width: 229px;
    box-sizing: border-box;
    padding: 20px;
    border-top: 1px solid #0d8b8c;
    margin-bottom: 20px;
}
.menuTitle {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 20px;
}
.menuli {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    cursor: pointer;
    margin-top: 10px;
}
.menuli:hover {
    color: #0b8485;
    text-decoration: underline;
}
.SCinput {
    width: 200px;
    height: 36px;
    box-sizing: border-box;
    border-top: 1px solid #007380;
    border-bottom: 1px solid #007380;
    border-left: none;
    border-right: none;
    outline: none;
    padding-left: 12px;
    vertical-align: middle;
}
.search {
    position: relative;
}
.SCimg {
    vertical-align: -13.9px;
    cursor: pointer;
}
.SCnum {
    display: inline-block;
    width: 80px;
    text-align: center;
    line-height: 36px;
    height: 36px;
    box-sizing: border-box;
    border: 1px solid #007380;
    border-right: none;
    vertical-align: -2.3px;
    cursor: pointer;
    position: relative;
}
.xiala {
    position: absolute;
    right: 0;
    top: 15px;
}

.letterWrap {
    width: 317px;
    height: 124px;
    border: 1px solid #007380;
    background: #fff;
    border-top: none;
    padding: 20px 17px;
    box-sizing: border-box;
    position: absolute;
    top: 36px;
}
.letter {
    width: 24px;
    height: 24px;
    display: inline-block;
    text-align: center;
    line-height: 24px;
    border-radius: 50%;
    cursor: pointer;
    font-family: Arial;
    font-weight: 400;
    color: #7e7e7e;
    margin-right: 5px;
    margin-bottom: 5px;
}
.letter:hover {
    background: #007380;
    color: #fff;
}
</style>
